module.exports = __webpack_public_path__ + "static/WEDDING E&M-171-753f5a2c60f41648c5bc1b8824992a5f.jpg";